import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMPRESSION_TYPE } from './useRetainerRequestForm';
import { SAVE_FORM_VALUES, SET_RETAINER_REQ_ID, SET_TOOTH_SELECTIONS } from '../../../store/DiffRetainers/actionType';
import { baseTeethValue } from '../../../store/DiffRetainers/reducer';

const useRetainerRequestSetFormValue = (
    singleRetainerTypeFormProps,
    upperAndLowerRetainerTypeFormProps,
    data,
    setImpressionType,
    setSpecialInstruction
) => {
    const diffRetainer = useSelector((state) => state.diffRetainer);
    const { supportedRetainerTypes, prescriptionFormValues } = diffRetainer;
    const dispatch = useDispatch();
    const mountRef = useRef(null);

    const getWireFelid = (retainerType, subType = undefined) => {
        let baseWireField = 'ecodontWireSelect';
        const isSubTypeValid = subType && ['Upper', 'Lower'].includes(subType);
        switch (retainerType) {
            case 'fixedPalatalWire':
                baseWireField = isSubTypeValid ? `${subType}PalatalWireSelect` : 'palatalWireSelect';
                break;
            case 'MDLSmartFitRetainersWithWire':
                baseWireField = isSubTypeValid ? `${subType}SmartFitWireSelect` : 'smartFitWireSelect';
                break;
            case 'ecodontRetainersWithWire':
                baseWireField = isSubTypeValid ? `${subType}EcodontWireSelect` : 'ecodontWireSelect';
                break;
            case 'ecodontRetainerWithWire_1set':
                baseWireField = isSubTypeValid
                    ? `${subType}EcodontRetainerWithWire_1setSelect`
                    : 'ecodontRetainerWithWire_1setSelect';
                break;
            default:
                break;
        }
        return baseWireField;
    };

    const getDefaultValue = useCallback((value, fieldType) => {
        if (fieldType === 'Array') {
            if (Array.isArray(value) && value.length > 0) {
                return value;
            }
            return undefined;
        }

        if (fieldType === 'String') {
            if (value && value.length > 0) {
                return value;
            }
            return undefined;
        }

        return value ? value : undefined;
    }, []);

    const handleSetSingleTypeFormValue = useCallback((singleRetainerTypeFormProps, retainerRequestPrescriptionNote) => {
        const setValue = singleRetainerTypeFormProps.methods.setValue;
        const key = retainerRequestPrescriptionNote.impression_type;
        const retainerTypes =
            Array.isArray(supportedRetainerTypes) && supportedRetainerTypes.length > 0 ? supportedRetainerTypes : [];
        const match = retainerTypes.find(
            (type) => type.retainer_type_id === retainerRequestPrescriptionNote[`${key}_retainer_type_id`]
        );
        const retainerType = match && match.retainer_type ? match.retainer_type : '';
        // Q1
        setValue('archAndQuantity', retainerType);
        const isFixedWire =
            retainerRequestPrescriptionNote[`${key}_fixed_wire`] === 1 ||
            retainerRequestPrescriptionNote[`${key}_fixed_wire`] === 'true';
        // need convert boolean to string for react-hook-form
        // Q2
        setValue('fixedWire', JSON.stringify(isFixedWire));
        // Q3
        // setValue('bleachingRetainersSelect' , getDefaultValue(retainerRequestPrescriptionNote[`${key}_bleaching_retainers_select`], 'Array'))
        setValue(
            'bleachingRetainersSelect',
            retainerRequestPrescriptionNote[`${key}_bleaching_retainers_select`] || ''
        );
        setValue('jigPlacementSelect', retainerRequestPrescriptionNote[`${key}_jig_placement_select`] || '');
        const wireSelectField = getWireFelid(retainerType);
        setValue(wireSelectField, retainerRequestPrescriptionNote[`${key}_wire_select`] || '');
        if (retainerType === 'ecodontRetainerWithVeneerShield_3set') {
            setValue('LowTrimlineAreaSelect_3', retainerRequestPrescriptionNote[`${key}_LowTrimlineAreaSelect_3`] || '');
        }
        if (retainerType === 'ecodontRetainerWithVeneerShield_1set') {
            setValue('LowTrimlineAreaSelect_1', retainerRequestPrescriptionNote[`${key}_LowTrimlineAreaSelect_1`] || '');
        }
        // Q4
        const isBiteRampValid =
            Array.isArray(retainerRequestPrescriptionNote[`${key}_bite_ramp`]) &&
            retainerRequestPrescriptionNote[`${key}_bite_ramp`].length > 0;
        console.log(singleRetainerTypeFormProps.formValues);
        let value = isBiteRampValid ? 'true' : 'false';
        const formSelection = singleRetainerTypeFormProps.formValues.occlusalBiteRampQuestion;
        if (formSelection === 'true') {
            value = 'true';
        }
        setValue('occlusalBiteRampQuestion', value);
        // Q5A
        const designUpper = retainerRequestPrescriptionNote[`${key}_clear_retainer_design_upper_option`] ? true : false;
        setValue('clearRetainerDesignUpper', designUpper);
        setValue(
            'clearRetainerDesignUpperOption',
            getDefaultValue(retainerRequestPrescriptionNote[`${key}_clear_retainer_design_upper_option`], 'String')
        );
        // Q5B
        const designLower = retainerRequestPrescriptionNote[`${key}_clear_retainer_design_lower_option`] ? true : false;
        setValue('clearRetainerDesignLower', designLower);
        setValue(
            'clearRetainerDesignLowerOption',
            getDefaultValue(retainerRequestPrescriptionNote[`${key}_clear_retainer_design_lower_option`], 'String')
        );
        // Q6A
        // const designUpperForSecondSet = retainerRequestPrescriptionNote[`${key}_clear_retainer_design_upper_option_for_second_set`] ? true : false
        // setValue('clearRetainerDesignUpperForSecondSet' , designUpperForSecondSet)
        // setValue('clearRetainerDesignUpperOptionForSecondSet' , getDefaultValue(retainerRequestPrescriptionNote[`${key}_clear_retainer_design_upper_option_for_second_set`]  , "String"))
        // Q6B
        // const designLowerForSecondSet = retainerRequestPrescriptionNote[`${key}_clear_retainer_design_upper_option_for_second_set`] ? true : false
        // setValue('clearRetainerDesignLowerForSecondSet' , designLowerForSecondSet)
        // setValue('clearRetainerDesignLowerOptionForSecondSet' , getDefaultValue(retainerRequestPrescriptionNote[`lower_clear_retainer_design_lower_option_for_second_set`] , "String"))
        // Q7
        const isPonticsValid =
            Array.isArray(retainerRequestPrescriptionNote[`${key}_pontics`]) &&
            retainerRequestPrescriptionNote[`${key}_pontics`].length > 0;
        setValue('pontics', isPonticsValid ? 'true' : 'false');

        setValue('pontic', getDefaultValue(retainerRequestPrescriptionNote[`${key}_pontic`], 'String'));
        setValue('ponticColor', getDefaultValue(retainerRequestPrescriptionNote[`${key}_pontic_color`], 'String'));

        setValue('specialInstruction', getDefaultValue(data.special_instruction, 'String'));
    }, []);

    const handleUpperAndLowerFormValue = useCallback(
        (upperAndLowerRetainerTypeFormProps, retainerRequestPrescriptionNote) => {
            const setValue = upperAndLowerRetainerTypeFormProps.methods.setValue;
            const data = retainerRequestPrescriptionNote;
            const upperMatch = supportedRetainerTypes.find(
                (type) => type.retainer_type_id === retainerRequestPrescriptionNote[`upper_retainer_type_id`]
            );
            const lowerMatch = supportedRetainerTypes.find(
                (type) => type.retainer_type_id === retainerRequestPrescriptionNote[`lower_retainer_type_id`]
            );

            const upperType = upperMatch && upperMatch.retainer_type ? upperMatch.retainer_type : '';
            const lowerType = lowerMatch && lowerMatch.retainer_type ? lowerMatch.retainer_type : '';

            // ==== Upper ====
            // Q2
            const isUpperFixedWire = data.upper_fixed_wire === 1 || data.upper_fixed_wire === 'true';
            setValue('UpperFixedWire', JSON.stringify(isUpperFixedWire));
            // Q3
            setValue('UpperArchAndQuantity', upperType);

            setValue('UpperBleachingRetainersSelect', data.upper_bleaching_retainers_select || '');
            const upperWireSelectField = getWireFelid(upperType, 'Upper');
            setValue(upperWireSelectField, data.upper_wire_select || '');
            setValue('UpperJigPlacementSelect', data.upper_jig_placement_select || '');
            if (upperType === 'ecodontRetainerWithVeneerShield_3set') {
                setValue('upper_low_trimline_area_select_3', data.upper_LowTrimlineAreaSelect_3 || '');
            }
            if (upperType === 'ecodontRetainerWithVeneerShield_1set') {
                setValue('upper_low_trimline_area_select_1', data.upper_LowTrimlineAreaSelect_1 || '');
            }
            // Q4
            const isUpperBiteRampValid = Array.isArray(data.upper_bite_ramp) && data.upper_bite_ramp.length > 0;
            let upperValue = isUpperBiteRampValid ? 'true' : 'false';
            const upperFormSelection = upperAndLowerRetainerTypeFormProps.formValues.UpperOcclusalBiteRampQuestion;
            if (upperFormSelection === 'true') {
                upperValue = 'true';
            }
            setValue('UpperOcclusalBiteRampQuestion', upperValue);
            // Q5A
            const upper_designUpper = data.upper_clear_retainer_design_upper_option ? true : false;
            setValue('UpperClearRetainerDesignUpper', upper_designUpper);
            setValue(
                'UpperClearRetainerDesignUpperOption',
                getDefaultValue(data.upper_clear_retainer_design_upper_option, 'String')
            );
            // Q5B
            // const upper_designLower = data.upper_clear_retainer_design_lower_option ? true : false
            // setValue('UpperClearRetainerDesignLower' ,upper_designLower)
            // setValue('UpperClearRetainerDesignLowerOption', getDefaultValue(data.upper_clear_retainer_design_lower_option , 'String'))
            // Q6A
            // const upper_designUpperForSecondSet = data.upper_clear_retainer_design_upper_option_for_second_set ? true : false
            // setValue('UpperClearRetainerDesignUpperForSecondSet' , upper_designUpperForSecondSet)
            // setValue('UpperClearRetainerDesignUpperOptionForSecondSet', getDefaultValue(data.upper_clear_retainer_design_upper_option_for_second_set , 'String'))
            // Q6B
            // const upper_designLowerForSecondSet = data.upper_clear_retainer_design_lower_option_for_second_set ? true : false
            // setValue('UpperClearRetainerDesignLowerForSecondSet' ,upper_designLowerForSecondSet)
            // setValue('UpperClearRetainerDesignLowerOptionForSecondSet', getDefaultValue(data.upper_clear_retainer_design_lower_option_for_second_set , 'String'))
            // Q7
            const isUpperPonticsValid = Array.isArray(data.upper_pontics) && data.upper_pontics.length > 0;
            setValue('UpperPontics', isUpperPonticsValid ? 'true' : 'false');

            setValue('UpperPontic', getDefaultValue(data.upper_pontic, 'String'));
            setValue('UpperPonticColor', getDefaultValue(data.upper_pontic_color, 'String'));

            // ==== Lower ====
            // Q2
            const isLowerFixedWire = data.lower_fixed_wire === 1 || data.lower_fixed_wire === 'true';
            setValue('LowerFixedWire', JSON.stringify(isLowerFixedWire));
            // Q3
            setValue('LowerArchAndQuantity', lowerType);

            setValue('LowerBleachingRetainersSelect', data.lower_bleaching_retainers_select || '');
            const lowerWireSelectField = getWireFelid(lowerType, 'Lower');
            setValue(lowerWireSelectField, data.lower_wire_select || '');
            setValue('LowerJigPlacementSelect', data.lower_jig_placement_select || '');
            if (lowerType === 'ecodontRetainerWithVeneerShield_3set') {
                setValue('LowerLowTrimlineAreaSelect_3', data.lower_LowTrimlineAreaSelect_3 || '');
            }
            if (lowerType === 'ecodontRetainerWithVeneerShield_1set') {
                setValue('LowerLowTrimlineAreaSelect_1', data.lower_LowTrimlineAreaSelect_1 || '');
            }
            // Q4
            const isLowerBiteRampValid = Array.isArray(data.lower_bite_ramp) && data.lower_bite_ramp.length > 0;
            let lowerValue = isLowerBiteRampValid ? 'true' : 'false';
            const lowerFormSelection = upperAndLowerRetainerTypeFormProps.formValues.LowerOcclusalBiteRampQuestion;
            if (lowerFormSelection === 'true') {
                lowerValue = 'true';
            }
            setValue('LowerOcclusalBiteRampQuestion', lowerValue);
            // Q5A
            // const designLower = data.lower_clear_retainer_design_upper_option ? true : false
            // setValue('LowerClearRetainerDesignUpper' ,designLower)
            // setValue('LowerClearRetainerDesignUpperOption', getDefaultValue(data.lower_clear_retainer_design_upper_option , 'String'))
            // Q5B
            const lower_designLower = data.lower_clear_retainer_design_lower_option ? true : false;
            setValue('LowerClearRetainerDesignLower', lower_designLower);
            setValue(
                'LowerClearRetainerDesignLowerOption',
                getDefaultValue(data.lower_clear_retainer_design_lower_option, 'String')
            );
            // Q6A
            // const lower_designUpperForSecondSet = data.lower_clear_retainer_design_upper_option_for_second_set ? true : false
            // setValue('LowerClearRetainerDesignUpperForSecondSet' , lower_designUpperForSecondSet)
            // setValue('LowerClearRetainerDesignUpperOptionForSecondSet', getDefaultValue(data.lower_clear_retainer_design_upper_option_for_second_set , 'String'))
            // Q6B
            // const lower_designLowerForSecondSet = data.lower_clear_retainer_design_lower_option_for_second_set ? true : false
            // setValue('LowerClearRetainerDesignLowerForSecondSet' , lower_designLowerForSecondSet)
            // setValue('LowerClearRetainerDesignLowerOptionForSecondSet', getDefaultValue(data.lower_clear_retainer_design_lower_option_for_second_set , 'String'))
            // Q7
            const isLowerPonticsValid = Array.isArray(data.lower_pontics) && data.lower_pontics.length > 0;
            setValue('LowerPontics', isLowerPonticsValid ? 'true' : 'false');

            setValue('LowerPontic', getDefaultValue(data.lower_pontic, 'String'));
            setValue('LowerPonticColor', getDefaultValue(data.lower_pontic_color, 'String'));

            setValue('specialInstruction', getDefaultValue(data.special_instruction, 'String'));
        },
        []
    );

    useEffect(() => {
        if (!data || !data.retainerRequestPrescriptionNote) return;
        const { retainerRequestPrescriptionNote } = data;

        if (!retainerRequestPrescriptionNote.impression_type) return;
        const isUpperAndLower = retainerRequestPrescriptionNote.impression_type === IMPRESSION_TYPE.UPPER_AND_LOWER;
        setImpressionType(retainerRequestPrescriptionNote.impression_type);
        setSpecialInstruction(retainerRequestPrescriptionNote.special_instruction);

        const handleFormValue = isUpperAndLower ? handleUpperAndLowerFormValue : handleSetSingleTypeFormValue;
        const formProps = isUpperAndLower ? upperAndLowerRetainerTypeFormProps : singleRetainerTypeFormProps;

        handleFormValue(formProps, retainerRequestPrescriptionNote);

        const validate = async () => {
            const isValid = await formProps.methods.trigger();
            if (isValid) {
                dispatch({
                    type: 'NEW_PATIENT_DATA_ERROR',
                    errorMsg: { id: 'retainer_request_prescription', valid: true, msg: '' },
                });
                mountRef.current = true;
            }
        };

        if (!mountRef.current) {
            validate();
        }
    }, [
        data,
        supportedRetainerTypes,
        setImpressionType,
        getDefaultValue,
        handleSetSingleTypeFormValue,
        handleUpperAndLowerFormValue,
    ]);

    useEffect(() => {
        if (!data || !data.retainerRequestPrescriptionNote) return;
        const teethValue = {
            // upper_pontics: data.retainerRequestPrescriptionNote?.upper_pontics ? data.retainerRequestPrescriptionNote?.upper_pontics : [],
            upper_bite_ramp: data.retainerRequestPrescriptionNote?.upper_bite_ramp
                ? data.retainerRequestPrescriptionNote?.upper_bite_ramp
                : [],
            // lower_pontics:  data.retainerRequestPrescriptionNote?.lower_pontics ? data.retainerRequestPrescriptionNote?.lower_pontics : [],
            lower_bite_ramp: data.retainerRequestPrescriptionNote?.lower_bite_ramp
                ? data.retainerRequestPrescriptionNote?.lower_bite_ramp
                : [],
        };

        // dispatch selected teeth into store for UI update
        // only work when fetched data from backend
        const dispatchSelectedTeethIntoStore = (impressionType, allSelectedTeeth) => {
            const key = impressionType;
            let payload = {
                ...baseTeethValue,
            };
            switch (impressionType) {
                case IMPRESSION_TYPE.UPPER:
                case IMPRESSION_TYPE.LOWER:
                    payload.toothBiteRamp = allSelectedTeeth[`${key}_bite_ramp`] || [];
                    // payload.toothPontics = allSelectedTeeth[`${key}_pontics`] || []
                    break;
                case IMPRESSION_TYPE.UPPER_AND_LOWER:
                    payload.upperToothBiteRamp = allSelectedTeeth['upper_bite_ramp'] || [];
                    // payload.upperToothPontics = allSelectedTeeth['upper_pontics'] || []
                    payload.lowerToothBiteRamp = allSelectedTeeth['lower_bite_ramp'] || [];
                    // payload.lowerToothPontics = allSelectedTeeth['lower_pontics'] || []
                    break;
                default:
                    break;
            }
            dispatch({ type: SET_TOOTH_SELECTIONS, payload: payload });
        };
        dispatchSelectedTeethIntoStore(data.retainerRequestPrescriptionNote.impression_type, teethValue);
    }, []);

    useEffect(() => {
        if (!data || !data.retainerRequestPrescriptionNote) return;
        if (data.retainerRequestPrescriptionNote && data.retainerRequestPrescriptionNote.retainer_request_id) {
            dispatch({ type: SET_RETAINER_REQ_ID, payload: data.retainerRequestPrescriptionNote.retainer_request_id });
        }
        return () => {
            dispatch({ type: SET_RETAINER_REQ_ID, payload: null });
        };
    }, [data]);
};

export default useRetainerRequestSetFormValue;
